import { render, staticRenderFns } from "./StatusCard.vue?vue&type=template&id=4247fe0c&scoped=true&"
import script from "./StatusCard.vue?vue&type=script&lang=ts&"
export * from "./StatusCard.vue?vue&type=script&lang=ts&"
import style0 from "./StatusCard.vue?vue&type=style&index=0&id=4247fe0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4247fe0c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
